import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "App-Bus-Right-Nav"
}
const _hoisted_2 = {
  "f-w-700": "",
  "txt-center": "",
  "m-tb-0": ""
}
const _hoisted_3 = {
  key: 0,
  "f-w-600": "",
  "txt-center": "",
  "m-tb-0": ""
}
const _hoisted_4 = {
  key: 0,
  "txt-center": "",
  "mute-secondary": ""
}
const _hoisted_5 = {
  "m-tb-1": "",
  "txt-center": ""
}
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_app_ent_standing = _resolveComponent("app-ent-standing")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.business)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$filters.capitalize(_ctx.business.name)), 1)
          ]),
          _createElementVNode("div", null, [
            (_ctx.business.industry)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_ctx.$filters.capitalize(_ctx.business.industry)) + " Industry ", 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.business.location)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.business.location.description), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_space, { size: 10 }, {
              default: _withCtx(() => [
                (_ctx.business.website)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.business.website,
                      target: "__blank"
                    }, [
                      _createVNode(_component_el_tag, {
                        "as-pointer": "",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyContent(_ctx.business.website))),
                        type: "primary",
                        "is-all-borderless": "",
                        round: ""
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("i", { class: "el-icon-link" }, null, -1),
                          _createTextVNode(" Website ", -1)
                        ]))]),
                        _: 1
                      })
                    ], 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_app_ent_standing, {
              labelSelf: `${_ctx.$filters.capitalize(_ctx.business.name)} (You)`,
              standingSelf: _ctx.business.standing,
              size: "mini"
            }, null, 8, ["labelSelf", "standingSelf"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}